// --------------------------------------------------------------------------
// Change payment - Switch between payment types on donation/appeals journey.
// --------------------------------------------------------------------------
// Author:      Zone
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

module.exports = function (options) {
    var ref = { $root: options.context, $document: jQuery(document) };
    var state = {
        monthly: null,
        multiplePaymentOptions: null,
        paymentMethodSelected: null
    };
    var props = {};
    var inactive = 'inactive';

    function render() {
        ref.$amountConfirmation.toggleClass(inactive, !state.paymentMethodSelected);
        ref.$paymentFields.toggleClass(inactive, !state.paymentMethodSelected);
        ref.$contactFields.toggleClass(inactive, !state.paymentMethodSelected);
        ref.$submit.toggleClass(inactive, !state.paymentMethodSelected);
        ref.$changePayment.toggleClass(inactive, !state.paymentMethodSelected || state.monthly || !state.multiplePaymentOptions);
        ref.$applePay.toggleClass(inactive, state.paymentMethodSelected || state.monthly);
        ref.$altPayment.toggleClass(inactive, state.paymentMethodSelected || state.monthly || !state.multiplePaymentOptions);
    }

    function init() {
        // Cache DOM elements
        ref.$applePay = ref.$root.find('[data-name="apple-pay"]');
        ref.$contactFields = ref.$root.find('[data-name="contact-details"]');
        ref.$paymentFields = ref.$root.find('[data-name="payment-details"]');
        ref.$submit = ref.$root.find('[data-name="form-submit"]');
        ref.$changePayment = ref.$root.find('[data-name="change-payment"]');
        ref.$altPayment = ref.$root.find('[data-name="alt-payment"]');
        ref.$amountConfirmation = ref.$root.find('[data-name="donation-form-confirmation"]');

        // Properties
        props.applePayEnabled = !!ref.$applePay.length;

        // Set state
        function initialState() {
            var $selectedTab = ref.$root.find('[data-binding="donation-tabs"]').filter('.active');
            var isMonthly = !!$selectedTab.length && $selectedTab.attr('data-state') === 'monthly';
            var multiplePaymentOptions = props.applePayEnabled && ref.$applePay.hasClass('available');

            return {
                monthly: isMonthly,
                multiplePaymentOptions: multiplePaymentOptions,
                paymentMethodSelected: !multiplePaymentOptions || isMonthly
            };
        }

        state = initialState();

        // Bind events
        ref.$root.on('change', '[data-name="donation-radio"]', function () {
            // If donation option changes, check if we are one-off or monthly

            // Check if month tab is active
            state = initialState();

            // Trigger render
            render();
        });

        ref.$root.on('click', '[data-name="alt-payment"]', function (event) {
            // If alt payment is clicked we need to update the UI

            event.preventDefault();

            // We have a payment method
            state.paymentMethodSelected = true;

            // Trigger render
            render();
        });

        ref.$root.on('click', '[data-name="change-payment"]', function (event) {
            // If change payment is clicked, revert form initial state
            event.preventDefault();

            // Update state to show no payment method
            state.paymentMethodSelected = !state.multiplePaymentOptions;

            // Trigger render
            render();
        });

        ref.$document.on('apple-pay:available', function () {
            // The ApplePay is available so multiplePaymentOptions will be true
            state = initialState();

            // Trigger render
            render();
        });

        // Render component
        render();
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/change-payment.js
// module id = 277
// module chunks = 0